import React, { useEffect } from 'react';
import { useStore } from '../../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import { Stack } from '@fluentui/react';
import NewsForm from '../../../components/settings/news/general/form';
import { useParams } from 'react-router-dom';

type TypeUpdateNewsPageProps = {
  children?: React.ReactNode;
};

const UpdateNewsPage: React.FC<TypeUpdateNewsPageProps> = (props) => {
  const { topbar } = useStore();
  const params: any = useParams();

  useEffect(() => {
    topbar.show("Update News", [
      { key: "home", icon: faHome, href: "/" },
      { key: "settings", text: 'Settings', href: "/settings" },
      { key: "news", text: 'Public News', href: "/settings/news" },
      { key: "news", text: 'Update News' }
    ])
  }, []);

  return (
    <Stack>
      <NewsForm newsId={params.newsId} />
    </Stack>
  )
};

export default UpdateNewsPage;